window.axios = require('axios');

import { createApp } from 'vue';
import { install } from 'vue3-recaptcha-v2';
import App from './App.vue';
import DataDirectory from "@/classes/DataDirectory";
import ApiManager from "@/classes/ApiManager";
import UnifiedApiManager from "@/classes/UnifiedApiManager";
import Accounting from "@/classes/Accounting";

import {createVuestic } from 'vuestic-ui';
import 'vuestic-ui/css';
import router from './router.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from 'vue-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Filters
// import * as Filters from '@/filters'

const app = createApp(App);

// Fontawesome
app.component('FontAwesomeIcon', FontAwesomeIcon);

library.add(faDollarSign);
library.add(faTimes);

// Vue.config.productionTip = false;
// Vue.prototype.$apiManager = window.apiManager = new ApiManager();
// Vue.prototype.$unifiedApiManager = window.unifiedApiManager = new UnifiedApiManager();
// Vue.prototype.$dataDirectory = new DataDirectory();
// Vue.prototype.$accounting = new Accounting();
app.config.productionTip = false;
app.config.globalProperties.$apiManager = window.apiManager = new ApiManager();
app.config.globalProperties.$unifiedApiManager = window.unifiedApiManager = new UnifiedApiManager();
app.config.globalProperties.$dataDirectory = new DataDirectory();
app.config.globalProperties.$accounting = new Accounting();
app.use(createVuestic());

// Import global filters
// Object.values(Filters).forEach((filter) => {
//   app.use(filter)
// })

// new Vue({
//   render: h => h(App),
//   router,
// }).$mount('#app')
app.use(router);

// reCaptcha
app.use(install, { sitekey: "6LcQClsiAAAAAEy1BejrR3u_AXMQ1zsXq-1cq4ja" });
app.mount('#app');